var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.node.hidden)?_c('div',{ref:"nodeElement",staticClass:"workflow__node",class:[
    ( _obj = {}, _obj[_vm.noPanClassName] = _vm.isDraggable, _obj.dragging = _vm.dragging, _obj.draggable = _vm.isDraggable, _obj.selected = _vm.node.selected, _obj.selectable = _vm.isSelectable, _obj.parent = _vm.node.isParent, _obj ),
    _vm.getClass
  ],style:(Object.assign({}, {visibility: _vm.isInit ? 'visible' : 'hidden',
    zIndex: _vm.node.computedPosition.z || _vm.zIndex,
    transform: ("translate(" + (_vm.node.computedPosition.x) + "px," + (_vm.node.computedPosition.y) + "px)"),
    pointerEvents: _vm.hasPointerEvents ? 'all' : 'none'},
    _vm.getStyle)),attrs:{"data-id":_vm.node.id},on:{"mouseenter":_vm.onMouseEnter,"mousemove":_vm.onMouseMove,"mouseleave":_vm.onMouseLeave,"contextmenu":_vm.onContextMenu,"click":_vm.onSelectNode,"dblclick":_vm.onDoubleClick}},[_c('VNodes',{attrs:{"nodes":_vm.NodeComponent}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }